import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseReviews } from '../../../../shared/reviews/components/reviews';

@Component({
  selector: 'app-reviews',
  imports: [BaseReviews],
  templateUrl: './reviews.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Reviews {}
